import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const CardContainer = styled.div`
  flex-direction: column;
  justify-content: space-evenly;
  border-radius: 12px;
  height: max-content;
  background-color: ${colors.background};

  @media (max-width: 1320px) {
    margin: 24px 20px;
  }
`
